"use client";

import { c as _c } from "react/compiler-runtime";
import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import { cn } from "cn";
import { popupSurface } from "@/components/ui/styles";
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
function PopoverContent(t0) {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      sideOffset: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn(popupSurface, "w-72 rounded-md p-4 outline-hidden", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <PopoverPrimitive.Popup className={t3} data-slot="popover-content" {...props} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== align || $[11] !== sideOffset || $[12] !== t4) {
    t5 = <PopoverPrimitive.Portal><PopoverPrimitive.Positioner align={align} sideOffset={sideOffset}>{t4}</PopoverPrimitive.Positioner></PopoverPrimitive.Portal>;
    $[10] = align;
    $[11] = sideOffset;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export { Popover, PopoverContent, PopoverTrigger };